import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import listsFile from "@/static-texts/lists.json";
import FiltersComponent from "./filters";
import * as annoucementSlice from "../build-your-solution.slice";

const BENEFICIARY_PLACEHOLDER = "Seleziona i beneficiari";
const OUTGOINGS_PLACEHOLDER = "Seleziona le spese";
const SECTOR_PLACEHOLDER = "Seleziona il settore";

const STATUS_PLACEHOLDER = "Seleziona lo status";

const ALL = "All";
const SECTOR = "Sector";
const BENEFICIARY = "Beneficiary";
const OUTGOINGS = "Outgoings";
const STATUS = "Status";
const { beneficiari, spese, settori, status } = listsFile;

function Filters({ nElements, isEnabled, listRef }) {
  const dispatch = useDispatch();

  var sort = useSelector(annoucementSlice.selecSortFilter);
  const filters = useSelector(annoucementSlice.selectDetailsFilters);
  const {
    statuses: initialStatuses,
    beneficiaries: initialBeneficiaries,
    outgoings: initialOutgoings,
    sectors: initialSectors,
  } = filters;

  const [isSectorFilterOpen, setSectorFilterOpen] = useState(false);
  const [isBeneficiaryFilterOpen, setBeneficiaryFilterOpen] = useState(false);
  const [isOutgoingsFilterOpen, setOutgoingsFilterOpen] = useState(false);
  const [isStatusFilterOpen, setStatusFilterOpen] = useState(false);

  const [selectedStatuses, setSelectedStatuses] = useState(
    initialStatuses ? initialStatuses : STATUS_PLACEHOLDER
  );
  const [statuses, setStatuses] = useState(
    initializeList(status, initialStatuses)
  );

  const [selectedBeneficiary, setSelectedBeneficiary] = useState(
    initialBeneficiaries ? initialBeneficiaries : BENEFICIARY_PLACEHOLDER
  );
  const [beneficiaries, setBeneficiaries] = useState(
    initializeList(beneficiari, initialBeneficiaries)
  );

  const [selectedOutgoing, setSelectedOutgoing] = useState(
    initialOutgoings ? initialOutgoings : OUTGOINGS_PLACEHOLDER
  );
  const [outgoings, setOutgoigs] = useState(
    initializeList(spese, initialOutgoings)
  );

  const [selectedSector, setSelecteSector] = useState(
    initialSectors ? initialSectors : SECTOR_PLACEHOLDER
  );
  const [sectors, setSectors] = useState(
    initializeList(settori, initialSectors)
  );

  useEffect(() => {
    const statusesTarget = statuses.filter(
      ({ isSelected }) => isSelected === true
    );

    if (statusesTarget?.length) {
      setSelectedStatuses(statusesTarget);
    } else {
      setSelectedStatuses(STATUS_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statuses]);

  useEffect(() => {
    if (selectedStatuses !== STATUS_PLACEHOLDER) {
      const list = toListOfNames(selectedStatuses);
      dispatch(annoucementSlice.setFilterStatuses({ selectedStatuses: list }));
    } else {
      setStatuses(initializeList(status));
      dispatch(annoucementSlice.setFilterStatuses({ selectedStatuses: [] }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatuses]);

  useEffect(() => {
    const beneficiaryTarget = beneficiaries.filter(
      ({ isSelected }) => isSelected === true
    );

    if (beneficiaryTarget?.length) {
      setSelectedBeneficiary(beneficiaryTarget);
    } else {
      setSelectedBeneficiary(BENEFICIARY_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [beneficiaries]);

  useEffect(() => {
    if (selectedBeneficiary !== BENEFICIARY_PLACEHOLDER) {
      const list = toListOfNames(selectedBeneficiary);
      dispatch(
        annoucementSlice.setFilterBeneficiaries({ selectedBeneficiary: list })
      );
    } else {
      setBeneficiaries(initializeList(beneficiari));
      dispatch(
        annoucementSlice.setFilterBeneficiaries({ selectedBeneficiary: [] })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBeneficiary]);

  useEffect(() => {
    const outgoingTarget = outgoings.filter(
      ({ isSelected }) => isSelected === true
    );
    if (outgoingTarget?.length) {
      setSelectedOutgoing(outgoingTarget);
    } else {
      setSelectedOutgoing(OUTGOINGS_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outgoings]);

  useEffect(() => {
    if (selectedOutgoing !== OUTGOINGS_PLACEHOLDER) {
      const list = toListOfNames(selectedOutgoing);
      dispatch(annoucementSlice.setFilterOugoings({ selectedOutgoing: list }));
    } else {
      setOutgoigs(initializeList(spese));
      dispatch(annoucementSlice.setFilterOugoings({ selectedOutgoing: [] }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOutgoing]);

  useEffect(() => {
    const sectorsTarget = sectors.filter(
      ({ isSelected }) => isSelected === true
    );
    if (sectorsTarget?.length) {
      setSelecteSector(sectorsTarget);
    } else {
      setSelecteSector(SECTOR_PLACEHOLDER);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectors]);

  useEffect(() => {
    if (selectedSector !== SECTOR_PLACEHOLDER) {
      const list = toListOfNames(selectedSector);
      dispatch(annoucementSlice.setFilterSectors({ selectedSector: list }));
    } else {
      setSectors(initializeList(settori));
      dispatch(annoucementSlice.setFilterSectors({ selectedSector: [] }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSector]);

  const handleBeneficiarySelect = ({ name }) => {
    setBeneficiaries(updateMuliChoiceList(name, beneficiaries));
  };

  const handleOutgoingSelect = ({ name }) => {
    setOutgoigs(updateMuliChoiceList(name, outgoings));
  };

  const handleSectorSelect = ({ name }) => {
    setSectors(updateMuliChoiceList(name, sectors));
  };
  const handleStatusSelect = ({ name }) => {
    setStatuses(updateMuliChoiceList(name, statuses));
  };

  const handleCancelFilterClick = () => {
    if (isEnabled) {
      setSelecteSector(SECTOR_PLACEHOLDER);
      setSelectedStatuses(STATUS_PLACEHOLDER);
      setSelectedOutgoing(OUTGOINGS_PLACEHOLDER);
      setSelectedBeneficiary(BENEFICIARY_PLACEHOLDER);
      dispatch(
        annoucementSlice.setDeatilsFilters({
          deatilsFilters: {
            statuses: [],
            beneficiaries: [],
            outgoings: [],
            sectors: [],
          },
        })
      );
      dispatch(
        annoucementSlice.setSortFilter({ sort: annoucementSlice.SORT.STATUS })
      );
    }
  };

  const handleOrderAscClick = () => {
    if (isEnabled) {
      dispatch(
        annoucementSlice.setSortFilter({ sort: annoucementSlice.SORT.ASC })
      );
    }
  };

  const handleOrderDescClick = () => {
    if (isEnabled) {
      dispatch(
        annoucementSlice.setSortFilter({ sort: annoucementSlice.SORT.DESC })
      );
    }
  };

  const handleHeaderClick = (listName) => {
    switch (listName) {
      case SECTOR:
        setBeneficiaryFilterOpen(false);
        setOutgoingsFilterOpen(false);
        setStatusFilterOpen(false);
        setSectorFilterOpen(true);
        break;
      case BENEFICIARY:
        setSectorFilterOpen(false);
        setOutgoingsFilterOpen(false);
        setStatusFilterOpen(false);
        setBeneficiaryFilterOpen(true);
        break;
      case OUTGOINGS:
        setSectorFilterOpen(false);
        setOutgoingsFilterOpen(true);
        setStatusFilterOpen(false);
        setBeneficiaryFilterOpen(false);
        break;
      case STATUS:
        setSectorFilterOpen(false);
        setOutgoingsFilterOpen(false);
        setStatusFilterOpen(true);
        setBeneficiaryFilterOpen(false);
        break;
      case ALL:
        setSectorFilterOpen(false);
        setOutgoingsFilterOpen(false);
        setStatusFilterOpen(false);
        setBeneficiaryFilterOpen(false);
        break;
      default:
        break;
    }
  };

  return (
    <FiltersComponent
      beneficiaries={beneficiaries}
      selectedBeneficiary={selectedBeneficiary}
      onBeneficiarySelect={handleBeneficiarySelect}
      outgoings={outgoings}
      selectedOutgoing={selectedOutgoing}
      onOutgoingSelect={handleOutgoingSelect}
      sectors={sectors}
      selectedSector={selectedSector}
      onSectorSelect={handleSectorSelect}
      statuses={statuses}
      selectedStatuses={selectedStatuses}
      onStatusSelect={handleStatusSelect}
      isEnabled={isEnabled}
      nElements={nElements === undefined ? 0 : nElements}
      onCancelFilterClick={handleCancelFilterClick}
      onOrderAscClick={handleOrderAscClick}
      onOrderDescClick={handleOrderDescClick}
      sort={sort}
      listRef={listRef}
      isSectorFilterOpen={isSectorFilterOpen}
      isBeneficiaryFilterOpen={isBeneficiaryFilterOpen}
      isOutgoingsFilterOpen={isOutgoingsFilterOpen}
      isStatusFilterOpen={isStatusFilterOpen}
      onHeaderClick={handleHeaderClick}
      isFilterSectorUsed={selectedSector !== SECTOR_PLACEHOLDER}
      isFilterBeneficiaryUsed={selectedBeneficiary !== BENEFICIARY_PLACEHOLDER}
      isFilterOutgoingsUsed={selectedOutgoing !== OUTGOINGS_PLACEHOLDER}
      isFilterStatusUsed={selectedStatuses !== STATUS_PLACEHOLDER}
    />
  );
}

function initializeList(list, selectedList) {
  return list.map((object) => {
    var found = selectedList?.find((value) => value === object.name);
    return {
      ...object,
      isSelected: found !== undefined,
    };
  });
}

function updateMuliChoiceList(name, list) {
  return list.map((obj) => {
    return {
      ...obj,
      isSelected: obj.name === name ? !obj.isSelected : obj.isSelected,
    };
  });
}

function toListOfNames(list) {
  return list.map(({ name }) => {
    return name;
  });
}

export default Filters;
